import { api } from "../../services/api"
import { gradationDashboardApi, paymentDashboardApi, purchaseOrderDashboardApi, paymentDashboardValueApi }  from "../../services/apiVariables" 
import { GetMonthYear, GetCurrentDate } from '@src/function.js'

// ----------------------Gradation----------------------------
export function gradationDashboard (offset) {
   return (dispatch) => {  
    dispatch({ type: 'Gradation_LOADING' }) 
     gradationDashboardApi.addOffset = offset
    api(gradationDashboardApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'Gradation_SUCCESS', data }),
           error => dispatch({ type:'Gradation_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}

// ----------------------Payment----------------------------
export function paymentDashboard (offset) {
   return (dispatch) => {  
    dispatch({ type: 'Payment_LOADING' }) 
     paymentDashboardApi.addOffset = offset
    api(paymentDashboardApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'Payment_SUCCESS', data }),
           error => dispatch({ type:'Payment_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}

// ----------------------Payment----------------------------
export function paymentValueDashboard (offset) {
   return (dispatch) => {  
    dispatch({ type: 'PaymentValue_LOADING' }) 
     paymentDashboardValueApi.addOffset = offset
    api(paymentDashboardValueApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'PaymentValue_SUCCESS', data }),
           error => dispatch({ type:'PaymentValue_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}

// ----------------------Purchase Order----------------------------
export function purchaseOrderDashboard () {
   return (dispatch) => {  
    dispatch({ type: 'PODashboard_LOADING' }) 
     // purchaseOrderDashboardApi.addOffset = offset
    api(purchaseOrderDashboardApi).then(response => response.json())  // convert to json
    .then(
           data => dispatch({ type: 'PODashboard_SUCCESS', data }),
           error => dispatch({ type:'PODashboard_ERROR', error: error.message || 'Unexpected Error!!!' })
       ) 
    }
}